export default "__VITE_ASSET__BDZTfSXr__"